import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './contratoItemForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, salvar, excluir, getLista } from './contratoItemActions';
import { setModoTela as setModoTelaContrato } from '../contrato/contratoActions';
import { getLista as getListaConvenio  } from '../hospitalConvenio/hospitalConvenioActions';
import { getLista as getListaExame } from '../exame/exameActions';

import FormatUtils from '../common/formatUtils/FormatUtils';

class ContratoItem extends Component {

	state = {
		linhaSelecionada: null
	}

	componentDidMount() {

	}

    componentWillMount() {
		this.props.getLista(this.props.id_contrato);
		this.props.getListaConvenio();
		this.props.getListaExame();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form id_hospital={this.props.id_hospital} onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form id_hospital={this.props.id_hospital} excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		let lista = (this.props.lista).filter(item => {
			if (this.state.pesquisar
				&& !(`${item.nome}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		});

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ id_contrato: this.props.id_contrato });
								}} />
						</Grid>
						<Grid cols='6 6 4 2'>
							<Button
								text='Voltar'
								type={'warning'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTelaContrato('lista');
									this.props.getLista(0);
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th>Convênio</Th>
								<Th alignCenter>Exame</Th>
								<Th alignRight>Valor Normal</Th>
								<Th alignRight>Valor Plantão</Th>
								<Th alignRight>Perc. Imposto</Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.nome_convenio}</Td>
									<Td alignCenter>{item.nome_exame}</Td>
									<Td alignRight>{FormatUtils.formatarValorTela(item.valor, 2)}</Td>
									<Td alignRight>{FormatUtils.formatarValorTela(item.valor_plantao, 2)}</Td>
									<Td alignRight>{FormatUtils.formatarValorTela(item.percentual_imposto, 2)}</Td>
									<Td alignRight minWidth={10}>																			
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													valor: FormatUtils.formatarValorTela(item.valor, 2),
													valor_plantao: FormatUtils.formatarValorTela(item.valor_plantao, 2),
													percentual_imposto: FormatUtils.formatarValorTela(item.percentual_imposto, 2)
												});
												this.props.initForm({
													...item,
													valor: FormatUtils.formatarValorTela(item.valor, 2),
													valor_plantao: FormatUtils.formatarValorTela(item.valor_plantao, 2),
													percentual_imposto: FormatUtils.formatarValorTela(item.percentual_imposto, 2)
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													valor: FormatUtils.formatarValorTela(item.valor, 2),
													valor_plantao: FormatUtils.formatarValorTela(item.valor_plantao, 2),
													percentual_imposto: FormatUtils.formatarValorTela(item.percentual_imposto, 2)
												});
												this.props.initForm({
													...item,
													valor: FormatUtils.formatarValorTela(item.valor, 2),
													valor_plantao: FormatUtils.formatarValorTela(item.valor_plantao, 2),
													percentual_imposto: FormatUtils.formatarValorTela(item.percentual_imposto, 2)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.contratoItem.modoTela,
	aguardando: state.contratoItem.aguardando,
	lista: state.contratoItem.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, setModoTelaContrato,
	getListaConvenio, getListaExame
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ContratoItem);